import { RadioOption } from 'components/form'
import { DesfechoUltimaGestacaoEnum } from 'graphql/types.generated'

export type FolhaRostoCirurgiaInternacaoModel = {
  idCirurgiaInternacao: ID
  descricao: string
  dataRealizada?: {
    data: Date
    idade: string
  }
}

export type FolhaRostoInformacoesObstetricasModel = {
  gestaPrevias?: string
  abortos?: string
  desfechoUltimaGestacao?: DesfechoUltimaGestacaoEnum
  partos?: string
  partosVaginais?: string
  partosCesareas?: string
  partosDomiciliares?: string
  nascidosVivos?: string
  natimortos?: string
  recemNascidoAbaixo?: string
  recemNascidoAcima?: string
  filhosVivos?: string
  obitoAntesPrimeiraSemana?: string
  obitoAposPrimeiraSemana?: string
}

export const desfechoUltimaGestacaoRecord: Record<DesfechoUltimaGestacaoEnum, string> = {
  [DesfechoUltimaGestacaoEnum.NAO_INFORMADO]: '',
  [DesfechoUltimaGestacaoEnum.MENOS_1_ANO]: '(Desfecho da última gestação aconteceu há menos de 1 ano)',
  [DesfechoUltimaGestacaoEnum.MAIS_10_ANOS]: '(Desfecho da última gestação aconteceu há mais de 10 anos)',
}

export const DESFECHO_ULTIMA_GESTACAO_OPTIONS: RadioOption<DesfechoUltimaGestacaoEnum>[] = [
  {
    label: 'Há menos de 1 ano',
    value: DesfechoUltimaGestacaoEnum.MENOS_1_ANO,
  },
  {
    label: 'Há mais de 10 anos',
    value: DesfechoUltimaGestacaoEnum.MAIS_10_ANOS,
  },
]
